export const RNC_VISUALIZAR_GRAFICOS_COMPRAS_PERMISSION = 'visualizar_graficos_compras';
export const RNC_EXPORTAR_EXCEL_PERMISSION = 'exportar_excel';
export const RNC_GRAFICOS_COMPRAS_CHART_IDS = ['fornecedores', 'fornecedores-por-tipo'];
export function canAccessRncGerenciaPage(hasPermission) {
    return (hasPermission('rnc', 'acessa_gerencia') ||
        hasPermission('rnc', RNC_VISUALIZAR_GRAFICOS_COMPRAS_PERMISSION));
}
export function canExportRncExcel(hasPermission) {
    return hasPermission('rnc', RNC_EXPORTAR_EXCEL_PERMISSION);
}
export function getGerenciarRNCAvailableTabs({ canAccessGestao, canAccessRelatorios, canAccessOcorrencias, canManageUsers, }) {
    const tabs = [];
    if (canAccessGestao) {
        tabs.push('gestao');
    }
    if (canAccessRelatorios) {
        tabs.push('relatorios');
    }
    if (canAccessOcorrencias) {
        tabs.push('ocorrencias');
    }
    if (canAccessGestao && canManageUsers) {
        tabs.push('usuarios');
    }
    return tabs.length > 0 ? tabs : ['gestao'];
}
export function getGerenciarRncAllowedChartIds({ canAccessGestao, canAccessGraficosCompras, }) {
    if (canAccessGraficosCompras && !canAccessGestao) {
        return [...RNC_GRAFICOS_COMPRAS_CHART_IDS];
    }
    return undefined;
}
